export const Header = (props) => {
  return (
    <header id="header" style={{ overflow: "hidden" }}>
      <div className="intro">
        <div className="overlay">
          <div className="container" style={{ padding: "0 15px" }}>
            <div className="row" style={{ margin: 0 }}>
              <div
                className="flex flex-col col-md-9 intro-text"
                style={{
                  padding: "0 15px",
                  // maxWidth: '100%',
                  animation: "fadeInUp 1s ease-out",
                }}
              >
                <h1
                  style={{
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    maxWidth: "100%",
                  }}
                >
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p
                  style={{
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    maxWidth: "100%",
                  }}
                >
                  {props.data ? props.data.paragraph : "Loading"}
                </p>
                <a
                  href="https://app.verifech.online/"
                  className="btn btn-custom btn-lg page-scroll"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    maxWidth: "100%",
                    whiteSpace: "normal",
                    animation: "fadeIn 1.5s ease-out",
                  }}
                >
                  Try it
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        #header * {
          box-sizing: border-box;
        }
        
        @media (max-width: 768px) {
          .intro-text h1 {
            font-size: 1.8rem !important;
          }
          
          .intro-text p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </header>
  );
};
